import React, { forwardRef } from 'react';
import moment from 'moment';
import { ReadNumber } from '~commons/read-number';

const MultipleOilSupplyTicket = forwardRef(({ data, companyInfo }, ref) => {
  const renderOilTicket = (dataItem) => {
    const assignOn = dataItem?.codeOil?.split('_')?.[2]?.split(' ')?.[0];
    const dateAssignOn = assignOn && assignOn?.split('/');
    const dateFormat = dateAssignOn && `${dateAssignOn[2]}-${dateAssignOn[1]}-${dateAssignOn[0]}`;

    const dataNumberCode = dataItem?.numberCode?.split('U&I');
    const displayNumberCode = dataNumberCode ? `${dataNumberCode[0]} U&I ${dataNumberCode[1]}` : '';

    const sumOilTotalSupply = dataItem?.car?.oilToSupply;
    return (
      <>
        <div style={{ border: '2px solid blue', marginLeft: '20px', width: '50%' }}>
          <div style={{ paddingLeft: '10px' }}>{dataItem?.companyName ?? companyInfo?.name}</div>
          <div
            style={{
              textAlign: 'center',
            }}
          >
            <b>PHIẾU CẤP NHIÊN LIỆU</b>
            <div>Số: {displayNumberCode} </div>
          </div>

          <div>
            <div style={{ padding: '0px 0px  0px 30px', margin: '0px' }}>
              <span>- Kính Gửi: Cửa Hàng Xăng Dầu</span>
              <div>- Chúng Tôi Đề Nghị Cửa Hàng Cấp Cho:</div>
            </div>

            <div style={{ border: '2px solid red', margin: '0px 10px', paddingLeft: '10px' }}>
              <span>- Lái Xe: </span>
              <b>{dataItem?.car?.driverMain}</b>
              <br />
              <span>- Số Xe: </span>
              <b>{dataItem?.car?.carCode}</b>
              <br />
              <span>- Lý Do: </span>
              <b>Chi Dầu Ngày {dateFormat && moment(dateFormat).format('DD-MM-YYYY')}</b>
              <br />
              <span>- Số Lượng: </span>
              <b>{sumOilTotalSupply}</b> Lít{' '}
              {dataItem?.car?.oilToSupplyExtra > 0 && (
                <span>(bao gồm {dataItem?.car?.oilToSupplyExtra} Lít hỗ trợ)</span>
              )}
              <br />
              <span>- Bằng Chữ: </span>
              <b>{ReadNumber(sumOilTotalSupply)}</b>
              <br />
              <span>- Ngày Cấp: </span>
              <b>{moment().format('DD/MM/YYYY')}</b>
              <br />
              <b>Phiếu có giá trị trong 3 ngày kể từ ngày cấp.</b>
            </div>
            <div style={{ display: 'flex' }}>
              <div style={{ marginLeft: 'auto', paddingRight: '20px' }}>
                Ngày {moment().format('DD')} Tháng {moment().format('MM')} Năm{' '}
                {moment().format('YYYY')}
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                textAlign: 'center',
                alignItems: 'center',
                marginBottom: '33px',
              }}
            >
              <div style={{ width: '32%', fontWeight: 'bold' }}>Duyệt</div>
              <div style={{ width: '32%', fontWeight: 'bold' }}>Lập phiếu</div>
              <div style={{ width: '32%', fontWeight: 'bold' }}>Lái Xe</div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const renderTickets = (item) => {
    return (
      <div key={item?.idOil}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            marginBottom: '10px',
          }}
        >
          {renderOilTicket(item)}
          {renderOilTicket(item)}
        </div>
        {/* {index > 0 && (index + 1) % 3 === 0 && <div style={{ height: '30px' }}></div>} */}
      </div>
    );
  };

  return <div ref={ref}>{data?.map(renderTickets)}</div>;
});

export { MultipleOilSupplyTicket };
